export default {

  "_En": "English",
  "_Jp": "Japanese",

  //header
  header_no_notification: ' No Notifications ',
  header_notification: 'Notifications',
  header_profile: 'Profile',
  header_companies: 'Companies',
  header_recruits: 'Recruits',
  header_my_company: 'My Company',
  header_engineers: 'Engineers',
  header_logout: 'Logout',

  //register
  r_title: 'INPUT PROFILE and SKILL',
  r_basic_info: 'Please tell me your basic information.',
  r_sub_basic_info: 'If you enter the following items, it will be easier to scout.',
  r_firstname: 'First Name',
  r_firstname_phonetic: 'First name (Phonetic)',
  r_select_firstname: 'Enter first name',
  r_lastname: 'Last Name',
  r_lastname_phonetic: 'Last name (Phonetic)',
  r_select_lastname: 'Enter Last name',
  r_nickname: 'Nick Name',
  r_initials: 'Initials',
  r_select_nickname: 'Enter nick name',
  r_email: 'Email',
  r_password: 'Password',
  r_c_password: 'Confirm Password',
  r_dob: 'Birthday',
  r_dob_year: 'Year',
  r_dob_month: 'Month',
  r_dob_day: 'Day',
  r_gender: 'Gender',
  r_g_male: 'Male',
  r_g_female: 'Female',
  r_location: 'Location',
  unify_test: 'Please enter',
  unify_test_pos: 'Please enter the role at that time',
  unify_test_what_resp: 'Please enter details',
  r_select: 'Please select',
  r_select_exp_corp: 'Please select the type of company that you had belonged to',
  r_experience: 'Experience',
  r_how_to_work: 'How to work',
  r_button: 'Register',
  r_registration_alert: "By signing up, you agree to our",
  r_term : 'Terms',
  r_poicy: 'Privacy Policy',
  r_END : '&',
  r_back_to_login: 'Already have a Account?',
  r_input_password_validation: 'Password must have at least 6 characters',
  r_password_validation: 'Password is required',
  r_current_password_validation: 'Current Password is required',
  r_c_input_password_validation: 'Password do not match',
  r_c_password_validation: 'Confirm Password is required',
  r_c_nickname_validation: 'only 20 characters allow',
  r_firstname_validation: 'FirstName is required',
  r_lastname_validation: 'Last Name is required',
  r_nickname_validation: 'NickName is required',
  r_c_email_validation: 'Must be valid e-mail',
  r_email_validation: 'Email is required',
  r_year_validation: 'Year is required',
  r_month_validation: 'Month is required',
  r_day_validation: 'Day is required',
  r_expertise_validation: 'Expertise is required',
  r_job_seeking_validation: 'Job-seeking situation is required',
  r_recommended_browser: '* We recommend you to register with the latest version of Google Chrome.',

  //login
  Login_title: 'SIGN IN',
  l_email: 'Email',
  l_password: 'Password',
  fdButtonTitle: 'Facebook',
  loginButtonTitle: 'Log in with your email address',
  forgotTitle: 'If you forget your password',
  nextTitle: 'The first one here (for engineer)',
  inquiryTitle: 'The first one here (for company)',
  passwordPlaceholder: 'Half size alphanumeric characters 6 characters or more',
  OR: 'or',
  sendVerificationLink: 'Send verification link',
  resendVerificationLink: 'resend verification mail?',

  //footer
  f_side1_title: 'Terms of Service',
  f_side2_title: 'Privacy Policy',
  f_side3_title: 'Contact Us',
  f_side4_title: 'About Us',
  f_copyright: 'Copyright© Digitalish CO., LTD. All Rights Reserved.',

  //error messages
  l_email_incorrect: 'Must be valid e-mail',
  l_password_incorrect: 'Password must have at least 6 characters.',

  //company-list
  c_title: "Let's look for the company",
  c_desc: 'You can approach by finding a company that matches you from various perspectives and sending your favorites and messages.',
  c_title_recruit: "Let's look for the recruit",
  c_desc_recruit: 'You can approach by finding out what you are interested in from the currently open recruits and sending your favorites and messages.',
  c_serach_result: 'Search result list',
  c_search_select: 'Select display order',
  c_search_keyword: 'Enter keywords',
  c_search_example: 'Example: PHP, Web, applications, etc.',
  c_shorting_check1: 'Hide end of recruitment',
  c_shorting_check2: 'Display only new arrival',
  c_button: 'concern!',
  c_andmore: 'And more',
  c_category: 'Category',
  comments_manager : 'Comments from the manager',

  //company-profile
  cp_title: 'My page',
  cp_desc: 'By registering application requirements and company information, you can appeal to engineers more.',
  cp_page: 'Company list',
  cp_basic_info: 'Basic information',
  cp_name: 'Company name',
  cp_location: 'location',
  cp_establishment: 'Establishment',
  cp_representative: 'Representative',
  cp_noe: 'Number of Employees',
  cp_company_desc: 'Company description',
  cp_service_desc: 'Service description',
  cp_button: 'Profile edit / update',

  //company-profile edit
  cp_edit_date: 'set up',
  cp_edit_update: 'Update',
  cp_dob_year: 'Year',
  cp_dob_month: 'Month',
  cp_dob_day: 'Day',
  cp_person: 'Person In Charge',
  cp_e_url: 'Enterprise URL',
  cp_industry: 'Industry',
  cp_job_cat: 'Job Category',
  cp_engineer_experience: 'Engineer Experience',
  cp_idea: 'Idea',
  cp_vision: 'Vision',
  cp_image_crop: 'Crop',
  cp_image_rotate: 'Rotate',
  cp_technique_stack: 'Technique Stack',
  cp_done: "Done",
  role_to_handle: 'Role to handle',
  select_role_to_handle: 'Enter Role to handle',
  update_password: "Update Password",
  current_password: "Current Password",
  change_password: "Change Password",
  error_changing_password: "Your current password does not matches with the password you provided. Please try again",
  password_updated: "Password changed successfully",

  //company-profile sidebar
  company_user_page: 'Top page',
  company_page: 'Company profile',
  job_offer: 'Job offer',
  all_engineers: 'All engineers',
  job_list: 'Recruit Page',
  recruit_list: 'Recruit List',
  recruiting_new_job: 'Recruiting new jobs',
  job_information_preview: 'Job information preview',
  talent: 'Talent',
  personnel_list: 'Personnel list',
  people_search: 'Find people',
  human_research_profile: 'Human resources profile',
  instrested_engineers_list: 'Interested engineers list',
  favorited_engineers: 'Favorited engineers',
  action: 'action',

  //action_list: 'Action list',
  option: 'Option',
  option_list: 'Option list',
  option_in_use: 'Options in use',
  other: 'Other',
  message: 'Message',
  chat: 'Chat',
  change_contract_plan: 'Change contract plan',
  company: 'Company',
  company_update: 'Company · Update',
  cp_other_sidebar: 'Edit profile',

  //usageguide
  usage_guide: 'Usage Guide',
  usage_guide_title1: 'Optional services are various services that engineers can freely select and use to concentrate on their work and grow.',
  usage_guide_title2: 'Please refer to the following for more information.',
  usage_guide_title3: 'Option Description For Engineers (PDF)',

  //company-list sidebar
  recruitment_situation: 'Recruitment situation',
  available: 'Available',
  all: 'All',

  company_established: "company established",
  one_year: "< 1 year",
  three_year: "< 3 years",
  five_year: "< 5 years",
  ten_year: "< 10 years",
  ten__year: "Over 10 years",

  business_type: 'type of business',
  btob: 'BtoB',
  btoc: 'BtoC',
  ctoc: 'CtoC',
  Sler: 'Sler',

  stage: 'listed / private',
  listed: 'Listed',
  non_listed: 'Non-listed',
  startup: 'startup',
  rounded: 'rounded',

  benefit: 'Benefit',
  remote_work: 'can remote work',
  flextime: 'Flextime',
  favorite_engineer: 'favorite engineer/oss commiter',
  dress_free: 'Dress free',
  sidework: 'can do sidework',
  stock_option: 'stock option',
  mac_windows_linux: 'Mac/Windows/Linux',
  free_drink: 'free drink',

  ratio_of_engineer: 'ratio of engineer',
  ten_per: '< 10%',
  ten_btw_thirty: '10% or > and < 30%',
  thirty_btw_fifty: '30% or > and < 50%',
  fifty_per: 'over 50%',

  recruitment_tension: "Recruitment Tension",
  asap: 'asap',
  good_person: 'if good person',
  disabled: 'disabled',

  job_type: 'full time/ part time',
  fulltime: 'fulltime',
  contractor: 'contractor',
  parttime: 'part time',
  freelancer: 'freelancer',

  contract: 'type of contract',
  only_full_time: 'only full time',
  hourly: 'shorter working hours',
  days: 'day of  1 - 4 days / week',
  work_office: 'work in office',
  sometime_remote_work: 'sometimes remote work',

  company_hire_engineer: 'company hire engineer',
  growing_business: 'growing business',
  luck_of_member: 'luck of member',
  current_position: 'alternetive current position',


  //company recruit add
  cr_title: 'Job Creation',
  cr_update: 'Job Update',
  cr_desc: 'Recruitment guidelines',
  cr_sub: 'Subject',
  cr_content: 'Content',
  cr_posting: 'Posting articles URL',
  cr_work_location: 'Work location',
  cr_button: 'Create',
  cr_supplement_fulltime_parttime: 'Supplement of full time/ part time',
  cr_supplement_contract: 'Supplement of type of contract',
  cr_bebefit_engineer: 'Benefits for engineers',
  cr_recruit_role: 'Recruit role',
  cr_process_project: 'How to proceed with project / development',
  cr_current_structure: 'Current structure',
  cr_skill_keyword: 'Skill keyword',
  required_technique_skill: 'required technique skill',
  better_technique_skill_if_there_is: 'better technique skill if there is',
  required_personality: "required personality",
  any_request: 'any request',

  //company detail
  cd_desc1: 'What kind of company?',
  cd_desc2: 'Philosophy / Vision',
  cd_recruit: 'Wanted items',
  cd_about: 'About us',
  cd_category: 'Category',

  // job list
  job_title: 'Job List',
  job_button: 'Create new recruitment',

  //recruit details
  recruit_copy: 'create a copy',
  recruit_title: 'Looking for a launch member of the collaborative platform "E3"!',
  recruit_freelance_type : 'The freelance type field is required.',
  recruit_contract_type : 'The contract type field is required.',
  recruit_sort_1: 'Newly registered recruits',
  recruit_sort_2: 'Newest order of last update date',

  //engineer profile
  ep_title: 'My page',
  ep_desc: 'By registering your own skills and backgrounds, you can appeal to companies more.',
  ep_page: 'Top page',
  ep_basic_info: 'Career,skill summary',
  ep_name: 'Name',
  ep_age: 'Age',
  ep_id: 'ID',
  ep_bday: 'Birthday',
  ep_sex: 'Gender',
  ep_location: 'Location',
  ep_howToWorkNow: 'How to work now',
  ep_howToWOrk: 'How to work',
  ep_decs_emp_con: 'Desired employment condition',
  ep_desc_emp_from: 'Desired employment form',
  ep_current_position: 'Current Position',
  ep_current_type_of_contract: 'Current Type of Contract',
  ep_required_position: 'Required Position',
  ep_requried_type_of_contract: 'Required Type of Contract',
  ep_national: 'National',
  ep_languages: 'Languages',
  ep_required_work_area_to_be: 'Required work area to be',
  engineer_years: 'Experienced corporate',
  ep_job_seeking: 'Job-seeking situation',
  expertise: 'Expertise',
  ep_engineer_notification: 'Engineer Notification',
  ep_desired: 'Desired income',
  ep_desired_error: 'be entered 0 or more',
  ep_currency_unit : 'yen or more',
  ep_policy: 'Policy',
  e_profile: 'Profile',
  e_score: 'Score',
  ep_button: 'Profile edit / update',

  ep_dob_year: 'Year',
  ep_dob_month: 'Month',
  ep_dob_day: 'Day',
  ep_email: 'Email',
  ep_change_email: 'Change Email',
  ep_male: 'Male',
  ep_female: 'Female',
  ep_firstname: 'First Name',
  ep_select_firstname: 'Enter first name',
  ep_lastname: 'Last Name',
  ep_select_lastname: 'Enter Last name',
  ep_experience: 'Experience',
  ep_select_policy: 'Enter Policy',
  ep_next: 'Next',

  ep_interview_completion_text: 'Your information will be made public by interviewing the administrator.',
  ep_interview_completion_text2: 'If you would like to make an appointment, please contact us from the inquiry page.',
  ep_interview_completion_button: 'the inquiry page',

  ep_past_job_details : 'Past job details',
  ep_past_job_details_error : 'at least 1 set to be created',
  ep_past_job_details_error2 : 'Please enter all items',
  ep_position_overview: 'Position Overview',
  ep_started_at: 'Start date',
  ep_ended_at: 'End date',
  ep_date_validation: 'start date can not be greater than end date',
  ep_your_responsibilities: 'What is your responsibilities',

  ep_email_verify_text: 'The mail address has not been authenticated yet. Would you like to send the authentication mail again?',
  ep_email_link: 'To resend',

  ep_initials_custom_validation: 'Please enter in English alphabet 1 letter and period and English alphabet 1 letter. Example; L.F',

  e_resumes : 'Resumes',

  //engineer-profile sidebar
  find_job: 'Find a job',
  scout: 'scout',
  unanswered: 'Unanswered',
  replay: 'Replay',
  company_list: 'Company list',
  all_companies: 'Search by companies',
  all_recruits: 'Search by recruits',
  companies_interested: 'Companies interested',
  favorite_company: 'Favorited companies',
  favorite_recruit: 'Favorited recruits',
  message_list: 'Message list',
  engineer_list: 'Engineer list',
  engineer_profile: 'Engineer profile detail',
  asked_price_person_who_was: 'Asked price Person who was',
  resume: 'resume',
  resume_UP: 'Resume UP',
  publishing_settings: 'Publishing Settings',
  page_item: 'item',
  ep_other_sidebar: 'Edit profile',
  last_login_time: 'Last login time',

  //engineer list
  el_title: "Let's look for a engineer",
  el_desc: 'You can find a engineer that matches your company from various perspectives and scout that person.',
  el_select: 'Select display order',
  el_new_user: 'Newly registered users',
  el_old_user: 'Old registered users',
  el_higher_total_score: 'Higher total score user',
  el_higher_technology_score: 'Higher technology score user',
  el_higher_management_score: 'Higher management score user',
  el_button: 'Asked price sent',
  el_bread: 'Outsourcing / outsourcing (individual business owner)',
  required_position: "Required Position",
  requried_type_of_contract: "Requried Type Of Contract",
  engineers_years: "Engineers Years",
  required_work_Area_to_be: "Required Work Area To Be",
  languages: "Languages",
  experienced_corporate: "Experienced Corporate",
  display_notifications_from_management: 'Display notifications from management',

  //chatroom
  chat_back: 'Back to My Page',
  back_chat_list: 'Back to Message list',
  chat_title: 'Looking for a launch member of the collaborative platform "E3"!',
  chat_select_file: 'Select the file',
  chat_select: 'not selected',
  chat_button: 'Send message',
  chatActiomSelectAll: 'Select All',
  download_attachment_file: 'Download Attachment',
  notice_from_the_management:'Notice from the management',

  no_result: "no result",
  no_more: "no more",

  Select_file: "Select file",

  //facebook button
  facebook_button: 'Sign in with Facebook',
  facebook_error_email: 'Email not found',
  facebook_enable: 'Enable Facebook login',
  facebook_connected: 'Connected',

  //forgot password
  forgotPassword: 'Forgot Password',
  forgotPasswordButton: 'Get Link',
  resetPassword: 'Reset Password',
  setPasswordButton: 'Set password',

  //engineer error messages
  err_unanswered: 'No any Unanswered yet.',
  err_replied: 'No any replay yet.',
  err_companyFavorited: 'There are no any company favorited',
  err_companyFavoritedByYou: 'No any Company favorited by you.',
  err_recruitFavorited: 'There are no any recruit favorited',
  err_favoritedEngineer: 'There are no any favorited engineer available',
  err_companyRegisterd: 'Company not register yet.',
  err_engineer: 'Engineer Not Found.',
  err_group: 'Groups not found.',
  err_conversation: 'No Conversation yet.',

  //company user error messages
  err_recruitAvailable: 'There are no any recruit available.',

  // global error messages
  err_startConversation: 'Start Conversation',
  err_pageNotFoundTitle: 'You Requested the page that is no longer There.',
  err_pageNotFoundBackToHome: 'Back To Home',
  err_pageNotFoundBackToSignin: 'Back To Signin',
  err_network: 'Network Error',
  err_admin: 'Admin not allow',
  err_skill: 'Please select atleast one skill',
  err_company_favorited: 'company removed to favorited',
  err_engineer_favorited: 'engineer removed to favorited',
  err_recruit_favorited: 'recruit removed to favorited',
  err_skill_not_found: 'skills not found',

  //success message
  success_register: "Signup successful !! Please Login!",
  success_register_completed: "Registration has been completed.",
  success_varify_user: "please sign in",
  success_forgot_password: "password set successful !! Please Login!",
  success_contact_us1: "Your email was recieved. We will get back soon",
  success_contact_us2: "Also please give me which template should I change.",
  success_edit_profile: "Edit profile Successful !!!",
  success_recruit_add: "Recruit Add Successfull !!!",
  success_recruit_update: "Recruit Update Successfull !!!",
  success_fevorited_list: "is removed from favorited list",
  success_reset_password: "Reset Password has been sent to your email.",
  success_change_mail: "Verification link has been sent to this email address.",
  success_skill: 'skill update successfull',
  success_company_favorited: "company added to favorited",
  success_engineer_favorited: "engineer added to favorited",
  success_recruit_favorited: "recruit added to favorited",
  success_engineer_notification: "Engineer Notification Add Successfull !!!",
  success_file_upload: "file uploaded successfully.",

  //contact inqury
  contact_title: 'Contact Us',
  contact_subtitle: 'Text enters Text comes in Text enters Text enters Text enters Text enters Text enters Text enters',
  contact_item: 'Inquiry contents',
  contact_button: 'Inquiry',
  contact_company_name: 'Enter Your Company Name',
  contact_name_palceholder: 'Enter Your Name',
  contact_name_error: 'name is required',
  contact_inquire_contant: 'Inquiry content is required',
  //privacy policy
  privacy_title: 'Privacy Policy',
  privacy_subtitle: 'Joint-venture company E3 (hereinafter referred to as "our company") creates a mechanism to create excellent IT engineers and provides services. Personal information policy (hereinafter referred to as "this policy") as the basic policy of our company regarding handling of personal information of customers (hereinafter referred to as "users") acquired within that.',

  //terms of service
  terms_title: 'Terms of Service',

  /*Engineer Skill Page*/
  sk_page_title: "Let's score your IT skills next.",
  sk_page_sub_title: 'Please answer the following questions.',
  sk_skill_update: 'Skill Update',
  sk_input_profile_skill_lb: 'INPUT PROFILE and SKILL',
  sk_total_lb: 'Total',
  sk_technical_lb: 'Technical',
  sk_management_lb: 'Management',
  sk_business_lb: 'Business',
  sk_selectskill_lb: 'Please Select Skill',
  sk_each_programming_lb: 'Select each level of programming language',
  sk_entrylevel_lb: 'Entry Level',
  sk_intermed_lb: 'Intermediate',
  sk_expert_lb: 'Expert',
  sk_result_lb: 'Result',
  sk_custom_placeholder: 'Feel free to input anything',
  sk_save_btn_lb: 'Save',
  sk_sentence1: 'Please distribute each item (skill) to the most applicable box.',
  sk_sentence2: 'If you select the skill (multiple selections possible) and then click on the applicable box, you can distribute it.',
  sk_sentence3: 'If there is no applicable item, there is no need to select it.',
  sk_asterisk: '*',
  sk_confirm: 'you have un saved items. are you sure to move back? or something.',

  about_defination: 'About Defination',

  definition: 'Definition',

  description_of_definitions: 'Description of definitions',
  definition_of_choice: 'Definition of choice',
  no_experience: 'no experience',
  no_experience_desc: '; there is no experience to work (Including studying for herself/himself)',
  experienced: 'experienced',
  experienced_desc: '; there is experience to work',
  no_confidence: 'no confidence',
  no_confidence_desc: "; it is impossible to make progress as far as information and instruction aren't provided",
  confident: 'confident',
  confident_desc: '; it is possible to accomplish proactively while adjusting schedule',
  very_confident: 'very confident',
  very_confident_desc: '; it is possible to teach the person while accomplishing proactively',
  know: 'know',
  know_desc: '; you have knowledge of what kind of characteristics it has',
  implement: 'it is imposible to implement',
  implement_desc: '; you can take up what has already been operated and operate without delay',
  set: 'it is imposible to set',
  set_desc: '; you can set up and operate it based on actual operation',
  build: 'it is imposible to build',
  build_desc: '; Constructed from 0 according to your requirements, you can operate',

  defination_intention: 'Definition of what I want to know (Intention)',
  occurred: 'how to cope when technique issue is occurred',
  occurred_desc: '; to know how much solving skill for problem she/he has',
  catch_up_technique: 'the method how to catch up technique',
  catch_up_technique_desc: '; to know self-learning skill',
  choose_technique: 'choose technique',
  choose_technique_desc: '; architect skill',

  definition_of_skill: 'Definition of skill',
  pmo: 'PMO experience (Project/Program Management Office)',
  pmo_desc: '; division and construction system which supports each PJ widely in organization',
  have_knowledge: 'have knowledge',
  have_knowledge_desc: '; have professional qualifications, or have experience in upstream design',
  pay_attention: 'pay attention',
  pay_attention_desc: '; collect information on media and books on a daily basis',
  have_know: 'known',
  have_know_desc: 'have knowledge',
  management_experienced: 'experienced',
  management_experienced_desc: '; there is experience to work',
  in: '* In ',
  in_desc1: 'information dispatch',
  in_desc2: ", it's defined as 'posting regularly or holding it'",

  what_i_want: 'Definition of what I want to know (Intention)',
  member_growing_up: 'concerning related to coaching and member growing up',
  member_growing_up_desc: '; to realize coaching skill',
  team_member: 'how to get higher motivation for team/member',
  team_member_desc: '; to realize the competence which leads project smoothly',
  bussiness_will_taken: 'what a kind of business will be taken?',
  bussiness_will_taken_desc: '; Whether it is a field utilizing experience, whether it is a challenge to a new field, future direction',

  trial_period: 'The free trial period has ended.',
  trial_period_desc: 'If you use the service in the future, please contact us regarding contracts from inquiries.',
  inquiry: 'To inquiry',
  logout: 'To log out',

  required_filed: 'This field is required',

  //tooltip
  tooltip_en_desc1: 'When searching with multiple keywords, please use plus sign for AND search and half-width space for OR search.',
  tooltip_en_desc2: 'e.g. AND search;',
  tooltip_en_desc3: 'OR search;',

  //pop-up
  pop_up_title: 'Current job seeking situation is',
  pop_up_it_ok: 'When updating to the latest information, you can update from "Change it".',
  pop_up_ok: 'OK',
  pop_up_unselected: 'Unselected',
  pop_up_change: 'Change it',

  //Setting mail
  setting_menu_name : 'Setting',
  setting_sub_had_name : 'Received mail setting',
  setting_item_text1 : 'Receive mail when you were favorited',
  setting_item_text2 : 'Receive mail when you got the message',

  setting_sub_had_name2 : 'Real name public setting',
  setting_item2_text1 : 'Publish real name to company user',

  real_name_setting_message : 'Your real name will only be published to the company that you sent the message.',

  publish_real_name: 'Publish real name when sending a message',

  past_job_period: 'Period',
  past_job_details: 'Details',

  communicate_title: 'Casual communication setting',
  communicate_sub_heading: 'Express intention to communicate casually',

  speech_bubble: "Let's talk casually!",

  //popover
  popover_desc1: 'TRIAL PLAN',
  popover_desc2: 'is the trial. You can send messages to engineers up to 3 people. If you receive the message from an engineer, it will not be counted.',
  popover_desc3: 'STANDARD PLAN',
  popover_desc4: 'has no limit on the number of engineers, and you can continue to use the service during the contract.',
  popover_desc5: 'Please inquire from the inquiry page for details.',

  maintenance_title: 'We’ll be back soon!',
  maintenance_sub_heading1: 'Sorry for the inconvenience but we’re performing some maintenance at the moment.',
  maintenance_sub_heading2: 'If you need to you can always',
  maintenance_sub_heading3: 'contact us,',
  maintenance_sub_heading4: ' otherwise we’ll be back online shortly!',

  payment_text : 'Payment',
  payment_employment_form : 'Employment form',
  payment_time_unit : 'Time unit',
  payment_lower_limit : 'Lower limit amount',
  payment_upper_limit : 'Upper limit amount',
  payment_upper_limit_validation : 'The upper limit must be greater than the lower limit',
  yen: 'yen',

  //resume-up
  resume_title : 'Resume UP',
  resume_desc1 : 'You can upload resumes.',
  resume_desc2 : 'All uploaded resumes will be published to the company.',

  delete_message : 'Record deleted Successesful'
};
